var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "b-modal",
        {
          attrs: { "ok-only": "", type: "warn", title: "Feedback sent" },
          on: {
            ok: function($event) {
              return _vm.$bvModal.hide("feedbackModal")
            }
          },
          model: {
            value: _vm.feedbackModalMessage,
            callback: function($$v) {
              _vm.feedbackModalMessage = $$v
            },
            expression: "feedbackModalMessage"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Thank your for your feedback. Someone from our team will look into the matter ASAP."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Feedback type" } },
            [
              _c(
                "b-form-radio",
                {
                  attrs: { name: "feedbackType", value: "feature request" },
                  model: {
                    value: _vm.feedbackType,
                    callback: function($$v) {
                      _vm.feedbackType = $$v
                    },
                    expression: "feedbackType"
                  }
                },
                [_vm._v("Requesting a feature")]
              ),
              _vm._v(" "),
              _c(
                "b-form-radio",
                {
                  attrs: { name: "feedbackType", value: "bug report" },
                  model: {
                    value: _vm.feedbackType,
                    callback: function($$v) {
                      _vm.feedbackType = $$v
                    },
                    expression: "feedbackType"
                  }
                },
                [_vm._v("I found a bug")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Message")]),
            _vm._v(" "),
            _c("ckeditor", {
              attrs: {
                editorUrl: "/js/ckeditor/ckeditor.js",
                config: _vm.editorConfig
              },
              model: {
                value: _vm.feedbackMessage,
                callback: function($$v) {
                  _vm.feedbackMessage = $$v
                },
                expression: "feedbackMessage"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", "data-dismiss": "modal" },
              on: { click: _vm.sendFeedback }
            },
            [_vm._v("Send")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }